import { object, ObjectSchema, string } from 'yup';

import { ContactInfoTypeDto } from '@/api/generated';
import { selectSearchOptionRequiredValidation } from '@/utils/form/selectSearchOptionOptional.validation.ts';
import { emailRegex, phoneRegex } from '@/utils/regex.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { AddContactInfoFormModel } from '@/views/contactsDetails/components/header/components/addContactInfoButton/model/AddContactInfoForm.model.ts';

export const useAddContactInfoFormValidation = (): ObjectSchema<AddContactInfoFormModel> => {
  const { t } = useTranslationWithPrefix('validation');

  return object().shape({
    contactInfoType: selectSearchOptionRequiredValidation<ContactInfoTypeDto>(string(), t).required(
      t('general.required'),
    ),
    note: string().optional().nullable(),
    value: string()
      .required(t('general.required'))
      .min(3, t('minLength', { min: 3 }))
      .test({
        message: t('email'),
        name: 'email',
        test: (value, context: { parent: AddContactInfoFormModel }) => {
          if (context.parent.contactInfoType?.value !== ContactInfoTypeDto.Email) {
            return true;
          }
          return emailRegex.test(value);
        },
      })
      .test({
        message: t('phone'),
        name: 'phone',
        test: (value, context: { parent: AddContactInfoFormModel }) => {
          if (context.parent.contactInfoType?.value !== ContactInfoTypeDto.Phone) {
            return true;
          }
          return phoneRegex.test(value);
        },
      }),
  });
};
